import * as Sentry from '@sentry/nextjs';
import NAMES from '~/constants/NAMES';
import { ITokenObj } from '~/types';

export const getToken = (): ITokenObj | null => {
  const tokenDataString = sessionStorage.getItem(NAMES.TOKEN);

  if (tokenDataString) {
    try {
      return JSON.parse(tokenDataString) as ITokenObj;
    } catch (err) {
      Sentry.captureException(err);
      return null;
    }
  }

  return null;
};

export default getToken;
